<template>
  <div class="container">
    <m-single-course-1 />
  </div>
</template>

<script>

export default {
  name: "SingleCourse",
}
</script>

<style scoped>

</style>